import { gql } from "@apollo/client";
import { logicaErrorBody } from "./helper";
import { createIdcToken } from "./helper";
import { v4 as uuidv4 } from "uuid";
import { UserInputError } from "apollo-server-errors";
import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import calcAge from "@/lib/calcAge";
import {
  SIGNUP_RESTRICTION_AGE,
  SIGNUP_RESTRICTION_AGE_MESSAGE,
} from "@/lib/constants";

export const typeDef = gql`
  type IdcAccessTokenResponse @cacheControl(scope: PRIVATE, maxAge: 0) {
    access_token: String
    expires_in: String
    refresh_token: String
    scope: String
    error: String
    error_description: String
    interval: String
  }
  type IdcUserInfo @cacheControl(scope: PRIVATE, maxAge: 0) {
    sub: String
    iss: String
    aud: String
    email: String
    name: String
    namekana: String
    gender: String
    birthdate: String
  }
  type IdcTokenVerifyInfo @cacheControl(scope: PRIVATE, maxAge: 0) {
    access_token: String
    token_type: String
    expires_in: String
    user_id: String
    elipsis_flg: String
    client_id: String
  }

  type Query {
    idcUserInfoEndPoint: IdcUserInfo
  }
  type Query {
    idcUserInfoEndPointAgeValidate: IdcUserInfo
  }
  type Query {
    idcTokenVerifyEndPoint: IdcTokenVerifyInfo
  }
  type Mutation {
    idcTokenEndPoint(code: String, redirectUri: String): IdcAccessTokenResponse
  }
`;

export const resolvers = {
  Query: {
    idcUserInfoEndPoint: async (_parent, args, { req, res, dataSources }) => {
      try {
        return await dataSources.idc.userInfoEndPoint();
      } catch (e) {
        console.log("error", e);
        return e;
      }
    },
    idcUserInfoEndPointAgeValidate: async (
      _parent,
      args,
      { req, res, dataSources }
    ) => {
      try {
        const idcUserInfo = await dataSources.idc.userInfoEndPoint();
        const birthday = idcUserInfo.birthdate?.replace(
          new RegExp("/", "g"),
          "-"
        );
        const age = calcAge(birthday);
        console.log("age:" + age);
        if (age < SIGNUP_RESTRICTION_AGE) {
          throw new UserInputError(SIGNUP_RESTRICTION_AGE_MESSAGE);
        }
        return idcUserInfo;
      } catch (e) {
        console.log("error", e);
        return e;
      }
    },
    idcTokenVerifyEndPoint: async (
      _parent,
      args,
      { req, res, dataSources }
    ) => {
      try {
        return await dataSources.idc.tokenVerifyEndPoint();
      } catch (e) {
        console.log("verify token error", e);
        console.log("verify token error code", e?.extensions?.code);
        throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);
      }
    },
  },
  Mutation: {
    idcTokenEndPoint: async (
      _parent,
      { code, redirectUri },
      { req, res, dataSources }
    ) => {
      try {
        const result = await dataSources.idc.tokenEndPoint(code, redirectUri);
        const token = await createIdcToken(
          req,
          res,
          result.access_token,
          result.refresh_token,
          result.id_token,
          uuidv4()
        );
        return result;
      } catch (e) {
        console.log("error", e);
        return e;
      }
    },
  },
};
